const mountInstallment = ({ properties, isInternational, currencyCode, total, currencyFilter }) => {
  if (!properties) return {}

  const value = isInternational ? properties.value_converted : properties.value
  const totalValue = isInternational ? properties.total_currency : total

  return {
    id: properties.installment,
    label: `${properties.installment}x ${currencyFilter(value, {
      codeCurrency: currencyCode,
    })}`,
    tributes: properties.tributes,
    subtotal: properties.subtotal,
    total: totalValue,
  }
}

export default mountInstallment
